import { scroll } from "../base/scroll";

export function toggleScroll(dir: "enable" | "disable") {
    if (!scroll) return;

    if (dir === "enable") scroll.start();
    else scroll.stop();
}

export const debounce = <T extends unknown[]>(callback: (...args: T) => void, delay: number) => {
    let timeoutTimer: ReturnType<typeof setTimeout>;

    return (...args: T) => {
        clearTimeout(timeoutTimer);

        timeoutTimer = setTimeout(() => {
            callback(...args);
        }, delay);
    };
};

export const sortByDistanceFromCenter = (elements: HTMLElement[]): HTMLElement[] => {
    const count = elements.length;
    const isEven = count % 2 === 0;

    return [...elements]
        .map((el, i) => ({
            el,
            distanceFromCenter: isEven ? Math.abs(i - (count / 2 - 0.5)) : Math.abs(i - Math.floor(count / 2)),
        }))
        .sort((a, b) => a.distanceFromCenter - b.distanceFromCenter)
        .map(o => o.el);
};
